<template>
  <nav class="navbar navbar-expand-md navbar-light bg-light shadow-sm sticky-top">
    <div class="container">
      <router-link class="navbar-brand d-flex align-items-center" to="/">
        <img src="@/assets/logo-main.webp" alt="Medicynia Logo" style="height: 3.5rem;" class="me-2"> <!-- Ajustar altura y margen -->
      </router-link>

      <!-- Botón Hamburguesa para móvil -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" @click="toggleMobileMenu">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menú (colapsable en móvil) -->
      <div class="collapse navbar-collapse" id="navbarNav" :class="{'show': isMobileMenuOpen}">
        <ul class="navbar-nav ms-auto mb-2 mb-md-0 align-items-center">
          <li class="nav-item">
            <router-link to="/" class="nav-link" @click="closeMobileMenu">Inicio</router-link>
          </li>
          <li class="nav-item">
            <a href="#features" @click.prevent="scrollTo('features', true)" class="nav-link">Características</a>
          </li>
          <li class="nav-item">
            <a href="#pricing" @click.prevent="scrollTo('pricing', true)" class="nav-link">Precios</a>
          </li>
          <li class="nav-item">
            <a href="#faq" @click.prevent="scrollTo('faq', true)" class="nav-link">Preguntas Frecuentes</a>
          </li>
          <li class="nav-item ms-md-2 mt-2 mt-md-0"> <!-- Margen y espaciado para botones -->
            <a href="https://app.medicynia.com/" class="btn btn-outline-dark btn-sm"  rel="noopener noreferrer">Iniciar Sesión</a>
          </li>
          <li class="nav-item ms-md-2 mt-2 mt-md-0 mb-2 mb-md-0"> <!-- Margen y espaciado para botones -->
            <router-link to="/signup" class="btn btn-primary btn-sm" @click="closeMobileMenu">Registrarse</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbar',
  data() {
    return {
      isMobileMenuOpen: false // Controla el estado 'show' manualmente
    };
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    scrollTo(sectionId, fromMobile = false) {
      if (fromMobile) {
        this.closeMobileMenu();
      }
      // Simplificar: Dejar que el scroll-padding-top global maneje el offset
      if (this.$route.path === '/') {
        const element = document.getElementById(sectionId);
        if (element) {
          // Esperar que el menú se cierre si viene de móvil
          // Bootstrap collapse puede necesitar un poco más de tiempo
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, fromMobile ? 300 : 0); // Aumentar timeout si es necesario
        }
      } else {
        // Navegar a la home y luego hacer scroll
        this.$router.push('/').then(() => {
           this.$nextTick(() => {
             const element = document.getElementById(sectionId);
             if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Pequeño delay para asegurar que la página está renderizada
             }
           });
        });
      }
    }
  }
}
</script>

<style scoped>
/* Estilos específicos si son necesarios, pero las clases de Bootstrap deberían cubrir la mayoría */
.navbar {
  /* Puedes añadir un z-index más alto si es necesario */
   z-index: 1030; /* Valor común para navbars fijas en Bootstrap */
}

/* Asegurar que el scroll padding funcione con la navbar fija */
html {
  scroll-padding-top: 70px; /* Ajusta este valor a la altura de tu navbar */
}

/* Estilos para el botón activo si es necesario */
.nav-link.active {
  font-weight: bold;
  /* color: var(--bs-primary); /* O el color que prefieras */
}

/* Ajustes menores para botones en móvil */
@media (max-width: 767.98px) {
  .navbar-nav .btn {
    width: calc(100% - 1rem); /* Hacer botones más anchos en móvil */
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
   .navbar-nav .nav-item:last-child .btn {
     margin-bottom: 0.5rem; /* Añadir espacio inferior al último botón */
   }
}
</style>
